var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"boxs"},[_c('div',{staticClass:"top"},[_c('p',{staticClass:"p"},[_vm._t("title")],2),_c('p',{staticClass:"more"},[_vm._t("more")],2)]),_c('div',{class:!_vm.flag?'contents':'contentsRight'},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }